import React, { Fragment } from "react";
import Header from "../header/Header";
import RecordingAdminPatients from "../patients/RecordingAdminPatients";
export default function RecordingAdminPatientDashboard() {
  return (
    <Fragment>
      <Header />
      <RecordingAdminPatients category={""} study_type="" />
    </Fragment>
  );
}
